import React, { useCallback } from "react";
import {
  matchPath,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { SearchEvent } from "../../SearchBar";
import { SearchDatabase } from "./SearchPage";
import { DetailsValueLinkType, getSearchURL } from "../title/SearchLink";

// generic URL param function to update search term for all database tabs
export function setSearchTermParam(params: URLSearchParams, term: string) {
  const updatedParams = new URLSearchParams(params);
  updatedParams.set("term", term);
  updatedParams.delete("page");
  updatedParams.delete("facetFilters"); // only applies to LS, but no harm, matches active tab behavior
  return updatedParams;
}
export function useSearchSubmit() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [currentParams] = useSearchParams();
  return useCallback(
    (event: SearchEvent) => {
      const match = matchPath(
        { path: "/search/:source", end: false },
        pathname
      );
      const type =
        event.searchType === "author" ? DetailsValueLinkType.author : null;
      // only use current params if we are on a results page with a search input
      const params = match
        ? new URLSearchParams(currentParams)
        : new URLSearchParams();
      const source =
        (match?.params.source as SearchDatabase) || SearchDatabase.LS;
      navigate(getSearchURL(event.searchTerm, type, source, params));
    },
    [currentParams.toString(), pathname]
  );
}
